/**
 * Converts an object to an array of objects with 'key' and 'value' properties
 * 
 * @param {Object} obj - The object to convert.
 * @returns {Array} An array of objects with key-value pairs.
 */

export const convertObjectToArray = (obj) => {
  console.log(obj, Object.entries(obj), Object.entries(obj).map(([key, value]) => ({
    key: key,
    value: value,
  })))
    return Object.entries(obj).map(([key, value]) => ({
      key: key,
      value: value,
    }));
  };

  /**
 * Converts an array of objects into an object keyed by a specified property.
 *
 * @param {Array<Object>} arr - The array of objects to convert.
 * @param {string} key - The property to use as the key for the resulting object.
 * @returns {Object} An object where each key is the value of the specified property
 *                   from an element in the array, and the value is the corresponding object.
 *
 */
export function convertArrayToObject(arr, key) {
  return arr.reduce((obj, item) => {
    if (item && item[key] !== undefined) {
      obj[item[key]] = item;
    }
    return obj;
  }, {});
}



/**
 * Delays the execution of a function by a specified number of milliseconds.
 * 
 * @param {number} ms - The delay time in milliseconds.
 * @returns {Promise} A promise that resolves after the specified delay.
 */
export const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const getVertexLabel = (index) => {
  const alphabet = 'abcdefghijklmnopqrstuvwxyz';
  const base = alphabet.length;

  const quotient = Math.floor(index / base);
  const remainder = index % base;

  let label = alphabet[remainder];
  if (quotient > 0) {
    label += quotient; // Append the count starting from 1
  }
  return label;
}
